import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Cookie同意",
      description: "此网站使用Cookie来增强您的浏览体验。点击“接受”，即表示您同意根据我们的Cookie政策使用Cookie。",
      accept: "接受Cookie",
      readMore: "要了解更多，请阅读我们的",
      privacyPolicy: "隐私政策",
      and: "和",
      termsOfService: "服务条款"
    },
    title: {
      resetPassword: "重置密码",
      welcome: "欢迎回来"
    },
    form: {
      displayName: "显示名称",
      email: "电子邮箱",
      password: "密码",
      newPassword: "新密码",
      forgotPassword: "忘记密码？",
      loading: "加载中...",
      signIn: "登录",
      signUp: "注册",
      resetPassword: "重置密码",
      sendResetLink: "发送重置链接",
      alreadyHaveAccount: "已有账号？登录",
      needAccount: "需要账号？注册",
      backToSignIn: "返回登录",
      orContinueWith: "或继续使用",
      google: "谷歌",
      facebook: "脸书",
      privacyPolicyAgreement: "点击注册，即表示您同意",
      privacyPolicy: "隐私政策",
      termsAgreement: "和",
      termsOfService: "服务条款"
    },
    toast: {
      missingInfo: {
        title: "信息缺失",
        description: "请提供电子邮箱和密码。"
      },
      missingName: {
        title: "信息缺失",
        description: "请提供显示名称。"
      },
      invalidEmail: {
        title: "无效的电子邮箱",
        description: "请输入有效的电子邮箱地址。"
      },
      invalidPassword: {
        title: "无效的密码",
        description: "密码长度必须至少为6个字符。"
      },
      emailNotVerified: {
        title: "邮箱未验证",
        description: "请检查您的收件箱并点击确认链接以验证您的邮箱。需要新链接？",
        resend: "重新发送"
      },
      verificationEmailSent: {
        title: "验证邮件已发送",
        description: "请检查您的收件箱中的确认链接。"
      },
      loginFailed: {
        title: "登录失败",
        description: "电子邮箱或密码无效。请重试或如果您没有账号，请注册。"
      },
      displayNameTaken: {
        title: "显示名称已被使用",
        description: "此显示名称已被使用。请选择其他名称。"
      },
      signUpSuccess: {
        title: "成功",
        description: "请查看您的邮箱获取确认链接！"
      },
      userAlreadyRegistered: {
        title: "注册失败",
        description: "此电子邮箱已注册。请尝试登录。"
      },
      resetEmailSent: {
        title: "查看您的邮箱",
        description: "我们已向您发送了密码重置链接。请检查您的收件箱。"
      },
      resetSuccess: {
        title: "成功",
        description: "您的密码已成功重置。请使用新密码登录。"
      },
      error: {
        title: "错误",
        description: "发生了意外错误。请重试。"
      },
      googleLoginError: {
        title: "谷歌登录错误",
        description: "无法使用谷歌登录。请重试。"
      },
      facebookLoginError: {
        title: "脸书登录错误",
        description: "无法启动脸书登录。请重试。"
      },
      samePassword: {
        title: "相同的密码",
        description: "新密码不能与旧密码相同。"
      },
      agreementRequired: {
        title: "协议要求",
        description: "请同意隐私政策和服务条款。"
      }
    }
  }
};
